import { defineAsyncComponent } from 'vue'
export default {
  "dashboard-layout": defineAsyncComponent(() => import("/app/app/layouts/dashboardLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  "login-layout": defineAsyncComponent(() => import("/app/app/layouts/loginLayout.vue").then(m => m.default || m)),
  "screen-with-navigation": defineAsyncComponent(() => import("/app/app/layouts/screenWithNavigation.vue").then(m => m.default || m))
}